<!-- eslint-disable -->
<template>
  <span>
    <span v-if="C_isSystemStatusLoaded">
      <span :class="C_systemStatusClass"></span>
    </span>

    <!--if its unknown we don't indicate either way -->
    <span class="c16_system_unknown" v-if="C_isSystemStatusUnKnown"></span>
  </span>
</template>

<script>
/* eslint-disable */

export default {
  name: "c16SysOnlineIndicator",
  props: ["systemUid", "isSystemVisible"],
  data() {
    return {
      DV_onlineObjectAttributeUid: null,
      DV_objectAttributeNewestValues: {}
    };
  },
  mounted() {
    const CI = this;

    CI.$nextTick(function() {

      if (CI.systemUid === null || CI.systemUid === undefined) {return;}

      //attribute 8 is reserved for processor online state
      CI.DV_onlineObjectAttributeUid = CI.systemUid.replace("sys_", "obj_atr_") + "-8";
      
      // CI.startSystemOnlineStatusListener();
      CI.DV_objectAttributeNewestValues = window.G_watchdog_data.IV_object_attribute_values;
    });
  },
  computed: {
    C_isSystemStatusLoaded() {
      const CI = this;

      return  CI.DV_onlineObjectAttributeUid !== null && 
              CI.DV_onlineObjectAttributeUid !== undefined &&
              CI.DV_objectAttributeNewestValues !== null &&
              CI.DV_objectAttributeNewestValues !== undefined &&
              CI.DV_onlineObjectAttributeUid in CI.DV_objectAttributeNewestValues &&
              CI.DV_objectAttributeNewestValues[CI.DV_onlineObjectAttributeUid] !== null && 
              CI.DV_objectAttributeNewestValues[CI.DV_onlineObjectAttributeUid] !== undefined && 
              'value' in CI.DV_objectAttributeNewestValues[CI.DV_onlineObjectAttributeUid];
    },
    C_systemStatusClass() {
      const CI = this;

      if (CI.DV_objectAttributeNewestValues[CI.DV_onlineObjectAttributeUid]['value']
          .toLowerCase()
          .indexOf('offline') > -1 ) {
        return "c16_system_offline"
      }

      if (CI.DV_objectAttributeNewestValues[CI.DV_onlineObjectAttributeUid]['value']
          .toLowerCase()
          .indexOf('online') > -1) {
        return "c16_system_online"
      }
    },
    C_isSystemStatusUnKnown() {
      const CI = this;

      return  CI.systemUid === null || CI.systemUid === undefined ||
              CI.DV_onlineObjectAttributeUid === null ||
              CI.DV_onlineObjectAttributeUid === undefined ||
              CI.DV_onlineObjectAttributeUid in CI.DV_objectAttributeNewestValues === false ||
              CI.DV_objectAttributeNewestValues[CI.DV_onlineObjectAttributeUid] === null ||
              CI.DV_objectAttributeNewestValues[CI.DV_onlineObjectAttributeUid] === undefined
    }
  },
  methods: {
    startSystemOnlineStatusListener() {
      const CI = this;
      
      window.G_watchdog_data.bi7SubscribeSystemOnlineStatus(CI.systemUid)
    },
    stopSystemOnlineStatusListener() {
      const CI = this;

      window.G_watchdog_data.bi7UnsubscribeSpecificListener('object_attribute_values', CI.DV_onlineObjectAttributeUid)
    }
  },
  watch: {
    systemUid() {
      const CI = this;

      if (CI.systemUid !== null && CI.systemUid !== undefined) {
        //attribute 8 is reserved for processor online state
        CI.DV_onlineObjectAttributeUid = CI.systemUid.replace("sys_", "obj_atr_") + "-8";
      }
    },
    isSystemVisible() {
      const CI = this;

      if (CI.isSystemVisible === true) {
        CI.startSystemOnlineStatusListener()
        return;
      }

      if (CI.isSystemVisible === false) {
        CI.stopSystemOnlineStatusListener()
        return;
      }

    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Labels/c16SysOnlineIndicator.vue